module.exports = __webpack_public_path__ + "img/nadim-rizk-2.46b0e8b6.jpg";